import { useContext } from 'react';

import { isEmpty, isNil } from 'ramda';
import { useHistory } from 'react-router-dom';

import LandingPageContext from 'components/shared/LandingPage/contexts/LandingPageContext';
import { ITINERARIES_ITEM_TYPES } from 'constants/index';
import { confirmAlert } from 'utils/alert';
import { useItinerariesItemContext } from 'utils/itineraries/context';
import { useItinerariesItemStepPath } from 'utils/itineraries/functions/useItinerariesItemStepPath';
import { ITINERARY_STEPS } from 'utils/itineraries/itinerary/map';

import { PAYMENT_STRATEGY_OPTIONS, ROOMING_TYPE_OPTIONS } from '../../Costs/constants';

function useCosts({ outerPage }) {
  const { readOnly, page } = useContext(LandingPageContext);
  const history = useHistory();
  const costs = page?.costs || outerPage?.costs;
  const costsCurrency = page?.costsCurrency || outerPage?.costsCurrency;
  const getStepPath = useItinerariesItemStepPath(ITINERARIES_ITEM_TYPES.ITINERARY);
  const itinerariesItemContext = useItinerariesItemContext();
  const isInsideItinerariesItemBuilder = !isNil(itinerariesItemContext);
  const notesEnabled = costs?.notesEnabled && Boolean(costs?.notesWysiwyg) && !isEmpty(costs?.notesWysiwyg?.data?.text);

  const handleClick = () => {
    if (readOnly || !isInsideItinerariesItemBuilder) return;

    confirmAlert({
      title: (
        <>
          Edits to this page can only be done in the Costs Tab. <br /> Do you want to go there now?
        </>
      ),
      confirmButtonText: 'Go to Costs Tab',
      onConfirm: () => {
        history.push(getStepPath(ITINERARY_STEPS.COSTS, itinerariesItemContext.itemId));
      },
    });
  };

  const type = PAYMENT_STRATEGY_OPTIONS.find((p) => p.value === costs.type)?.value;
  const accommodationType = ROOMING_TYPE_OPTIONS.find((r) => r.value === costs.accommodationType)?.value;

  return { handleClick, ...costs, costsCurrency, type, accommodationType, notesEnabled };
}

export default useCosts;
